import React from "react";
import { inject } from "mobx-react";
import { Modal, Form, Input } from "antd";

import CascaderSelect from "./cascaderSelect";
import UploadSchoolBadge from "./uploadSchoolBadge";
import Language from "../../language/language";

import { $util } from "../../../helper";

@inject("languageStore")
class UpdateSchoolInfo extends React.Component {
  state = {
    confirmLoading: true,
    // 以下字段是否本来已有，则不允许改为空
    nameTag: false,
    enNameTag: false,
    shortNameTag: false,
    shortEnNameTag: false
  };

  componentDidMount() {
    const info = this.props.info;
    if (info) {
      const { name, enName, shortName, shortEnName } = info;
      this.setState({
        nameTag: !!name,
        enNameTag: !!enName,
        shortNameTag: !!shortName,
        shortEnNameTag: !!shortEnName
      });
    }
  }

  handleCancel = () => {
    this.props.onCancel && this.props.onCancel();
  };

  getPlaceHolder = (lang, action, item) =>
    `${this.props.languageStore.getResource(lang, action)}${this.props.languageStore.getResource(
      lang,
      item
    )}`;

  getSchoolAddressData = info => {
    if (!info) return null;
    const { country, countryCode, province, provinceCode, city, cityCode } = info;
    if (country || countryCode) {
      return {
        country: {
          value: countryCode,
          label: country
        },
        province: {
          value: provinceCode,
          label: province
        },
        city: {
          value: cityCode,
          label: city
        }
      };
    }
    return null;
  };

  judgeEmpty = (rule, value, callback) => {
    const { required, lang, label } = rule;
    if (required && !value) {
      callback(
        this.props.languageStore.getResource(lang, "IS_REQUIRED_INPUT", [
          this.props.languageStore.getResource(lang, label)
        ])
      );
      return;
    }
    callback();
  };

  // 校验中文全称
  validatorName = (rule, value, callback) => {
    const enName = this.props.form.getFieldValue("enName");
    const { nameTag } = this.state;
    const { lang, label } = rule;
    const shortName = this.props.form.getFieldValue("shortName");

    if (nameTag && !value) {
      callback(
        this.props.languageStore.getResource(lang, "IS_REQUIRED_INPUT", [
          this.props.languageStore.getResource(lang, label)
        ])
      );
      return;
    }
    if (!value && !enName) {
      callback(this.props.languageStore.getResource(lang, "SCHOOL_FULL_NAME_CAN_NOT_EMPTY"));
      return;
    }
    if (shortName && !value) {
      callback(
        this.props.languageStore.getResource(lang, "IS_REQUIRED_INPUT", [
          this.props.languageStore.getResource(lang, label)
        ])
      );
      return;
    }
    callback();
  };

  // 校验中文简称
  validatorShortName = (rule, value, callback) => {
    const name = this.props.form.getFieldValue("name");
    const { shortNameTag } = this.state;

    const { lang, label } = rule;
    if (shortNameTag && !value) {
      callback(
        this.props.languageStore.getResource(lang, "IS_REQUIRED_INPUT", [
          this.props.languageStore.getResource(lang, label)
        ])
      );
      return;
    }
    if (name && !value) {
      callback(
        this.props.languageStore.getResource(lang, "IS_REQUIRED_INPUT", [
          this.props.languageStore.getResource(lang, label)
        ])
      );
      return;
    }
    // 简称：中英文都只能有16个字符，就是8个汉字，16个字母以内。
    if (name && value) {
      const charNum = $util.checkCharNum(value);
      if (charNum > 16) {
        callback(this.props.languageStore.getResource(lang, "SCHOOL_SHORT_NAME_ZH_LIMIT"));
        return;
      }
    }
    callback();
  };

  // 校验英文全称
  validatorEnName = (rule, value, callback) => {
    const name = this.props.form.getFieldValue("name");
    const shortEnName = this.props.form.getFieldValue("shortEnName");
    const { enNameTag } = this.state;
    const { lang, label } = rule;
    if (enNameTag && !value) {
      callback(
        this.props.languageStore.getResource(lang, "IS_REQUIRED_INPUT", [
          this.props.languageStore.getResource(lang, label)
        ])
      );
      return;
    }

    if (!value && !name) {
      callback(this.props.languageStore.getResource(lang, "SCHOOL_FULL_NAME_CAN_NOT_EMPTY"));
      return;
    }

    if (shortEnName && !value) {
      callback(
        this.props.languageStore.getResource(lang, "IS_REQUIRED_INPUT", [
          this.props.languageStore.getResource(lang, label)
        ])
      );
      return;
    }
    callback();
  };

  // 校验英文简称
  validatorShortEnName = (rule, value, callback) => {
    const enName = this.props.form.getFieldValue("enName");
    const { shortEnNameTag } = this.state;
    const { lang, label } = rule;
    if (shortEnNameTag && !value) {
      callback(
        this.props.languageStore.getResource(lang, "IS_REQUIRED_INPUT", [
          this.props.languageStore.getResource(lang, label)
        ])
      );
      return;
    }
    if (enName && !value) {
      callback(
        this.props.languageStore.getResource(lang, "IS_REQUIRED_INPUT", [
          this.props.languageStore.getResource(lang, label)
        ])
      );
      return;
    }
    // 简称：中英文都只能有16个字符，就是8个汉字，16个字母以内。
    if (enName && value) {
      const charNum = $util.checkCharNum(value);
      if (charNum > 16) {
        callback(this.props.languageStore.getResource(lang, "SCHOOL_SHORT_NAME_EN_LIMIT"));
        return;
      }
    }
    callback();
  };

  // 校验地址
  validatorSchoolAddress = (rule, value, callback) => {
    const { lang } = rule;
    if (!value) {
      callback(
        this.props.languageStore.getResource(lang, "IS_REQUIRED_INPUT", [
          this.props.languageStore.getResource(lang, "SCHOOL_COUNTRY")
        ])
      );
      return;
    }
    callback();
  };

  validatorSchoolBadge = (rule, value, callback) => {
    const { lang } = rule;
    if (!value) {
      callback(
        this.props.languageStore.getResource(lang, "IS_REQUIRED_INPUT", [
          this.props.languageStore.getResource(lang, "SCHOOL_BADGE")
        ])
      );
      return;
    } else if (typeof value === "object") {
      const { imageUrl, typeChecked, largeChecked, sizeChecked } = value;
      if (!imageUrl) {
        callback(
          this.props.languageStore.getResource(lang, "IS_REQUIRED_INPUT", [
            this.props.languageStore.getResource(lang, "SCHOOL_BADGE")
          ])
        );
        return;
      }
      if (!typeChecked || !largeChecked || !sizeChecked) {
        callback(
          this.props.languageStore.getResource(this.props.languageStore.lang, "SCHOOL_BADGE_ERROR")
        );
        return;
      }
    }
    callback();
  };

  formatFormValues = values => {
    const { schoolAddress, schoolBadge, name, shortName, enName, shortEnName } = values;
    const { city, country, province } = schoolAddress;
    const data = {
      name: name || "",
      shortName: shortName || "",
      enName: enName || "",
      shortEnName: shortEnName || "",
      schoolBadge: schoolBadge.imageUrl,
      // 国家
      country: country.label,
      countryCode: country.value,
      // 省份
      province: province ? province.label : "",
      provinceCode: province ? province.value : "",
      // 城市
      city: city ? city.label : "",
      cityCode: city ? city.value : ""
    };
    if (this.props.info && this.props.info.id) {
      return Object.assign(data, { id: this.props.info.id });
    }
    return data;
  };

  updateInfo = data =>
    this.props
      .onOk(data)
      .then(() => {
        this.setState({
          confirmLoading: false
        });
      })
      .catch(() => {
        this.setState({
          confirmLoading: false
        });
      });

  handleOnOk = () => {
    this.props.form.validateFields(
      { first: false, firstFields: [], force: true },
      (err, values) => {
        if (!err) {
          Modal.confirm({
            iconType: "exclamation-circle",
            title: this.props.languageStore.getResource(
              this.props.languageStore.lang,
              "UPDATE_PERSONAL_INFO_CONFIM_TIPS"
            ),
            okText: this.props.languageStore.getResource(
              this.props.languageStore.lang,
              "KICK_OUT_CONFIRM"
            ),
            cancelText: this.props.languageStore.getResource(
              this.props.languageStore.lang,
              "KICK_OUT_CANCEL"
            ),
            onOk: () => {
              this.setState({
                confirmLoading: true
              });
              const data = this.formatFormValues(values);
              data && this.updateInfo(data);
            }
          });
        }
      }
    );
  };

  verifyForm = () =>
    this.props.form.validateFields(
      { first: false, firstFields: [], force: true },
      (err, values) => {}
    );

  handleFormChange = () => {
    // 表单值更新以后校验全部表单
    this.verifyForm();
  };

  isSchoolBadgeReady = () => {
    this.setState(
      {
        confirmLoading: false
      },
      this.verifyForm
    );
  };

  render() {
    const { confirmLoading } = this.state;
    const { visible, info, title } = this.props;
    const { getFieldDecorator } = this.props.form;
    const lang = this.props.languageStore.lang;
    const labelColSpan = lang === "zh" ? 6 : 10;
    const modalWidth = lang === "zh" ? "550px" : "650px";
    const schoolAddressData = this.getSchoolAddressData(info);

    const formItemLabelList = [
      {
        label: "SCHOOL_FULL_NAME_ZH",
        itemName: "name",
        inputAction: "ENTER",
        component: Input,
        validator: this.validatorName
      },
      {
        label: "SCHOOL_SHORT_NAME_ZH",
        itemName: "shortName",
        inputAction: "ENTER",
        component: Input,
        validator: this.validatorShortName
      },
      {
        label: "SCHOOL_FULL_NAME_EN",
        itemName: "enName",
        inputAction: "ENTER",
        component: Input,
        validator: this.validatorEnName
      },
      {
        label: "SCHOOL_SHORT_NAME_EN",
        itemName: "shortEnName",
        inputAction: "ENTER",
        component: Input,
        validator: this.validatorShortEnName
      },
      {
        label: "SCHOOL_ADDRESS",
        itemName: "schoolAddress",
        inputAction: "SELECT",
        component: CascaderSelect,
        validator: this.validatorSchoolAddress,
        type: "any"
      },
      {
        label: "SCHOOL_BADGE",
        itemName: "schoolBadge",
        inputAction: "SELECT",
        component: UploadSchoolBadge,
        validator: this.validatorSchoolBadge,
        onReady: this.isSchoolBadgeReady
      }
    ];

    return (
      <Modal
        width={modalWidth}
        title={title}
        visible={visible}
        onOk={this.handleOnOk}
        okText={<Language resource="SAVE" />}
        cancelText={<Language resource="KICK_OUT_CANCEL" />}
        confirmLoading={confirmLoading}
        onCancel={this.handleCancel}
        maskClosable={false}
      >
        <Form layout="horizontal" onChange={this.handleFormChange}>
          {formItemLabelList.map((item, index) => {
            const {
              label,
              inputAction,
              component: InputComponent,
              itemName,
              validator,
              type = "string",
              ...restProps
            } = item;
            const placeholder = this.getPlaceHolder(lang, inputAction, label);
            const formLabl = <Language resource={label} />;
            const initialValue = info
              ? itemName === "schoolAddress"
                ? schoolAddressData
                : info[itemName]
              : null;

            return (
              <Form.Item
                key={index}
                label={formLabl}
                labelCol={{ span: labelColSpan, offset: 0 }}
                wrapperCol={{ span: 24 - labelColSpan, offset: 0 }}
              >
                {getFieldDecorator(itemName, {
                  validateFirst: false,
                  initialValue: initialValue,
                  rules: [
                    {
                      lang,
                      label,
                      validator,
                      type
                    }
                  ]
                })(
                  <InputComponent
                    className="personalInfoInput__item--input"
                    placeholder={placeholder}
                    {...restProps}
                  />
                )}
              </Form.Item>
            );
          })}
        </Form>
      </Modal>
    );
  }
}

export default Form.create({})(UpdateSchoolInfo);



// WEBPACK FOOTER //
// ./src/components/common/teamInfo/updateSchoolInfo.js